module.exports = __webpack_public_path__ + "img/05.4e581d5f.jpg";